import { ApolloClient, InMemoryCache, from } from "@apollo/client";
import { createUploadLink } from "apollo-upload-client";
import { onError } from "@apollo/client/link/error";
import { setContext } from "@apollo/client/link/context";
import { relayStylePagination } from "@apollo/client/utilities";
import axios from "axios";
import {
  osName,
  osVersion,
  mobileModel,
  mobileVendor,
  browserName,
  browserVersion,
} from "react-device-detect";

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = localStorage.getItem("token");
  // return the headers to the context so httpLink can read them

  return {
    headers: {
      ...headers,
      Authorization: token ? `JWT ${token}` : "",
      ip: localStorage.getItem("ip"),
      os: osName,
      deviceName: browserName,
      platform: "web",
      appVersion: "1.0",
    },
  };
});

const errorLink = onError(
  ({ graphQLErrors, networkError, operation, forward }) => {
    // Graphql Error handling
    if (graphQLErrors) {
      graphQLErrors.forEach(({ message, extensions, locations, path }) => {
        if (
          message === "Signature has expired" ||
          message === "You are not authorized user." ||
          message === "Unauthorized user!"
        ) {
          localStorage.removeItem("token");
          localStorage.removeItem("refresh");
          window.location.href = "/admin/login";
        }
      });
    }

    // If network error happening
    if (networkError) {
    }
  }
);

const link = from([
  errorLink,
  new createUploadLink({ uri: `${process.env.REACT_APP_BASE_URL}graphql/` }),
]);

const options = {
  typePolicies: {
    Query: {
      fields: {
        users: relayStylePagination(),
        members: relayStylePagination(),
        notifications: relayStylePagination(),
        vehicles: relayStylePagination(),
        logs: relayStylePagination(),
        products: relayStylePagination(),
        scheduledClasses: relayStylePagination(),
        employees: relayStylePagination(),
        classes: relayStylePagination(),
        allNutritionPlans: relayStylePagination(),
        allTrackNutritionPlans: relayStylePagination(),
        lockers: relayStylePagination(),
        memberLockers: relayStylePagination(),
        allDietPlanPackages: relayStylePagination(),
        allPersonalTrainingPackages: relayStylePagination(),
        allMembershipPackages: relayStylePagination(),
        allDietPlanPackageBookings: relayStylePagination(),
        allPersonalTrainingPackageBookings: relayStylePagination(),
        allMembershipPackageBookings: relayStylePagination(),
        suppliers: relayStylePagination(),
        allWorkOuts: relayStylePagination(),
        allFoods: relayStylePagination(),
        allMealTypes: relayStylePagination(),
        allSessions: relayStylePagination(),
        allBodyMeasurementTracks: relayStylePagination(),
        uomList: relayStylePagination(),
        productUomList: relayStylePagination(),
        returnableProducts: relayStylePagination(),
        salesReturnableProducts: relayStylePagination(),
        purchaseOrders: relayStylePagination(),
        purchaseReceipts: relayStylePagination(),
        purchaseReturns: relayStylePagination(),
        invoices: relayStylePagination(),
        invoiceReceipts: relayStylePagination(),
        salesReturns: relayStylePagination(),
        banks: relayStylePagination(),
        categories: relayStylePagination(),
        expenses: relayStylePagination(),
        accountLedger: relayStylePagination(),
        ledgerGroups: relayStylePagination(),
        ledgerAccounts: relayStylePagination(),
        accountGroups: relayStylePagination(),
        groupReport: relayStylePagination(),
        addressTypes: relayStylePagination(),
        durationTypes: relayStylePagination(),
        productTypes: relayStylePagination(),
        diseaseTypes: relayStylePagination(),
        designationTypes: relayStylePagination(),
        countries: relayStylePagination(),
        regions: relayStylePagination(),
        cities: relayStylePagination(),
        departments: relayStylePagination(),
        deductionTypes: relayStylePagination(),
        maritalStatuses: relayStylePagination(),
        leaveTypes: relayStylePagination(),
        employeeOvertimes: relayStylePagination(),
        employeeSettlements: relayStylePagination(),
        employeeDeduction: relayStylePagination(),
        employeeBonuses: relayStylePagination(),
        employeeLoans: relayStylePagination(),
        employeeAttendances: relayStylePagination(),
        memberAttendances: relayStylePagination(),
        sessionAttendances: relayStylePagination(),
        employeeDeductions: relayStylePagination(),
        employeeLeaves: relayStylePagination(),
        allNotifications: relayStylePagination(),
        allNotificationTemplates: relayStylePagination(),
        branches: relayStylePagination(),
        session: relayStylePagination(),
        sessionWorkouts: relayStylePagination(),
        registeredDoors: relayStylePagination(),
        genders: relayStylePagination(),
        memberClassBookings: relayStylePagination(),
        workOutCategories: relayStylePagination(),
        classWorkouts: relayStylePagination(),
        openDoorRequests: relayStylePagination(),
        membershipFreezingRequests: relayStylePagination(),
        sportsAndEventsList: relayStylePagination(),
        BMITracks: relayStylePagination(),
        waterIntakeList: relayStylePagination(),
        loyaltyPointsTracks: relayStylePagination(),
        activeMembers: relayStylePagination(),
        eventParticipants: relayStylePagination(),
        businessCategoryList: relayStylePagination(),
      },
    },
  },
};

export const Client = new ApolloClient({
  cache: new InMemoryCache(options),
  link: authLink.concat(link),
});
